import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="site-footer">
    <span>Aviral Kumar Srivastava</span>
    <a href="https://github.com/aviraw" target="_blank" rel="noopener noreferrer">GitHub</a>
    <a href="https://www.linkedin.com/in/aviralkumarsrivastava/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
  </footer>
);

export default Footer;
